module.exports = __webpack_public_path__ + "7b745463db013c663282663237738889.woff2";